import React from 'react';
import PropTypes from 'prop-types';
// Custom
import SvgIcons from 'components/core/SvgIcons';

const AppIcon = ({ id, ...otherProps }) => {
  const Icon = SvgIcons[id];
  if (Icon) {
    return <Icon {...otherProps} />;
  }
  return null;
};

AppIcon.propTypes = {
  id: PropTypes.string.isRequired,
};

export default AppIcon;



// WEBPACK FOOTER //
// ./components/icons/AppIcon.js